import React, { ChangeEventHandler } from "react"
import { BsChatQuoteFill } from "react-icons/bs"
import useT from "utils/useT"

type Props = {
  value: string
  onChange: ChangeEventHandler<HTMLTextAreaElement>
}

const NameInput = ({ value, onChange }: Props) => {
  const t = useT()
  return (
    <div className="input-style has-borders has-icon validate-field mt-2">
      <i style={{ top: "13px" }}>
        <BsChatQuoteFill />
      </i>
      <textarea
        maxLength={200}
        style={{ height: "auto" }}
        className="form-control validate-password"
        id="bio"
        name="bio"
        value={value}
        rows={5}
        placeholder={t.signup.bioPlaceholder}
        onChange={onChange}
      />
    </div>
  )
}

export default NameInput
